<template>
  <div class="i-base-bullet-item">
    <img
      :src="props.iconUrl"
      loading="lazy"
      alt=""
      class="icon"
    />
    <div
      class="text"
      :style="props.textStyle"
    >
      {{ props.text }}
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  iconUrl: {
    type: String,
    default: "https://uploads-ssl.webflow.com/63b58013b3cc40c26785e355/63b58014b3cc40010a85e3f5_CheckCircle%20Green.svg"
  },
  text: {
    type: String,
    default: "Bullet Item Text"
  },
  textStyle: {
    type: Object,
    default: () => {
      return {}
    }
  }
})
</script>

<style lang="scss" scoped>
.i-base-bullet-item {
  display: flex;
  margin-bottom: 12px;
  justify-content: flex-start;
  align-items: center;

  .icon {
    width: 24px;
    height: 24px;
    margin-right: 8px;
  }

  .text {
    font-size: 14px;
    line-height: 120%;
  }
}

@media screen and (min-width: $breakpoint-md) {
  .i-base-bullet-item {
    .icon {
      width: 32px;
      height: 32px;
      margin-right: 16px;
    }

    .text {
      font-size: 16px;
    }
  }
}
</style>
